export default "__VITE_ASSET__mlKX_i6S__"